import {
  RUDDERSTACK_READY_RETRY,
  RudderstackIntegrations,
  USER_GEO_IP_LOCATION_KEY,
} from 'constants/common'
import { RudderEvent } from 'constants/rudderEvents'
import { getUserLocation } from './common'

type Integrations = {
  [key in RudderstackIntegrations]?: boolean
}

type LogEventCallback = () => void

const logEvent = (
  eventName: RudderEvent,
  data = {},
  integrations?: Integrations,
  onTracked?: LogEventCallback,
  retryCount = 0
): void => {
  const defaultIntegrations = {
    [RudderstackIntegrations.GOOGLE_ADS]: false,
    [RudderstackIntegrations.GOOGLE_TAG_MANAGER]: false,
    [RudderstackIntegrations.FACEBOOK_PIXEL]: false,
    ...(!!integrations && integrations),
  }

  if (globalThis.rudderanalytics) {
    const userLocation = getUserLocation()

    // Integrations stay in the 3rd options arg; callback is the 4th arg.
    const options = {
      integrations: defaultIntegrations,
      ...(userLocation && {
        location: {
          [USER_GEO_IP_LOCATION_KEY]: userLocation,
        },
      }),
    }

    globalThis.rudderanalytics.track(eventName, data, options, onTracked)
  } else {
    // When there is an event that's fired on component mount, there is a chance where the log event doesn't get triggered
    // So to avoid that we retry the event after a small delay
    if (retryCount >= RUDDERSTACK_READY_RETRY.MAX_RETRIES) {
      // eslint-disable-next-line no-console
      console.error(
        'logEvent failed after maximum retries, rudderanalytics not initialized'
      )
      onTracked?.()
      return
    }

    setTimeout(() => {
      logEvent(eventName, data, integrations, onTracked, ++retryCount)
    }, RUDDERSTACK_READY_RETRY.DELAY_MS)
    return
  }

  // Also send all events to Heap https://thriveworks.atlassian.net/browse/THRIV-4731
  // `track` only exists once `heap.load()` has run, which requires analytics consent.
  if (
    process.env.NEXT_PUBLIC_HEAP_APP_ID &&
    typeof globalThis.heap?.track === 'function'
  ) {
    globalThis.heap.track(eventName, data)
  }
}

export default logEvent
